<template>

  <div style="background:#485077;">
    <el-menu ref="main2" style="background:#485077" model="vertical" unique-opened theme="dark"
             :default-active="$route.path" :collapse="isCollapse" @open="handleOpen" @close="handleClose"
             background-color="#485077" text-color="#cdc9c9" active-text-color="#fff">
      <div class="sidebarOut">
        <el-image style="width: 80%" :src="logo"></el-image>
      </div>
      <!-- <sidebar-item :routes='menus'></sidebar-item> -->
      <sidebar-item style="margin-top:8.5vh" :routes='permissionMenus'></sidebar-item>
    </el-menu>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import SidebarItem from './SidebarItem';


import Cookies from 'js-cookie';

import logo from '../../imges/LOGO.png'
export default {
  data () {
    return {
      logo,
      s2: '',
      s3: '',
      // LSID:"",
      LSID: 1980001,
      menus: [
        {
          sid: 'index',
          sname: '个人中心',
          slink: '/index',
          sdesc: 'el-icon-my',
          sdescon: 'el-icon-my-on',
          chlist: [
            // {
            //   sid: 'indexPage',
            //   sname: '首页1',
            //   slink: '/index/indexPage',
            //   sdesc: require('../../imges/4.png'),
            // },
            {
              sid: 'grsb',
              sname: '我的申报',
              slink: '/index/grsb',
              sdesc: '',

            },
            {
              sid: 'wdtb',
              sname: '我的提报',
              sdesc: require('../../imges/4.png'),
              son: [
                {
                  sid: 'wdht',
                  sname: '我的合同',
                  slink: '/index/wdht',
                },
                {
                  sid: 'wdcg',
                  sname: '我的成果',
                  slink: '/index/wdcg',
                },
              ]
            }
            // {
            //   sid: 'cs',
            //   sname: '首页2',
            //   // slink: '/index/csindex',
            //   sdesc: require('../../imges/4.png'),
            //   // son: [
            //   //   {
            //   //     sid: 'csindex',
            //   //     sname: '首页22',
            //   //     slink: '/index/csindex',
            //   //   },
            //   // ]
            // }
          ]
        },
        {
          sid: 'xmgl',
          sname: '项目管理',
          slink: '/xmgl',
          sdesc: 'project',
          sdescon: 'project-on',
          chlist: [
            {
              sid: 'xmsb',
              sname: '项目申报',
              slink: '/xmgl/xmsb',
            },
            {
              sid: 'xmshlb',
              sname: '项目审核列表',
              slink: '/xmgl/xmshlb',
            },
            {
              sid: 'xmlbgl',
              sname: '项目列表管理',
              slink: '/xmgl/xmlbgl',
            },
            {
              sid: 'htxz',
              sname: '合同新增',
              slink: '/xmgl/htxz',
            },

            {
              sid: 'htshlb',
              sname: '合同审核列表',
              slink: '/xmgl/htshlb',
            },
            {
              sid: 'htlbgl',
              sname: '合同列表管理',
              slink: '/xmgl/htlbgl',
            },
            {
              sid: 'cgxz',
              sname: '成果新增',
              slink: '/xmgl/cgxz',
            },

            {
              sid: 'cgshlb',
              sname: '成果审核列表',
              slink: '/xmgl/cgshlb',
            },
            {
              sid: 'cglbgl',
              sname: '成果列表管理',
              slink: '/xmgl/cglbgl',
            },
          ]
        },
        {
          sid: 'platform',
          sname: '产教融合平台管理',
          slink: '/platform',
          sdesc: 'platform',
          sdescon: 'platform-on',
          chlist: [
            {
              sid: 'PlatformManage',
              sname: '平台管理',
              slink: '/platform/PlatformManage'
            }
          ]
        },
        {
          sid: 'council',
          sname: '理事会',
          slink: '/council',
          sdesc: 'council',
          sdescon: 'council-on',
          chlist: [
            {
              sid: 'councilMembers',
              sname: '理事会成员管理',
              slink: '/council/councilMembers',
            },
            {
              sid: 'CouncilMinutes',
              sname: '会议纪要文件管理',
              slink: '/council/CouncilMinutes',
            },
            {
              sid: 'CouncilNotice',
              sname: '通知公告管理',
              slink: '/council/CouncilNotice',
            },
            {
              sid: 'CouncilNews',
              sname: '新闻动态管理',
              slink: '/council/CouncilNews',
            },
            {
              sid: 'CouncilNewsCheckOk',
              sname: '成员单位资讯列表',
              slink: '/council/CouncilNewsCheckOk',
            },
            {
              sid: 'CouncilCoordinationOk',
              sname: '成员单位合作需求列表',
              slink: '/council/CouncilCoordinationOk',
            },
            {
              sid: 'CouncilNewsCheck',
              sname: '成员单位资讯审核',
              slink: '/council/CouncilNewsCheck',
            },
            {
              sid: 'CouncilCoordination',
              sname: '成员单位合作需求审核',
              slink: '/council/CouncilCoordination',
            },
            {
              sid: 'CouncliSet',
              sname: '理事会设置',
              slink: '/council/CouncliSet',
            },
          ]
        },
        {
          sid: 'industrialCollege',
          sname: '产业学院',
          slink: '/industrialCollege',
          sdesc: 'industrialCollege',
          sdescon: 'industrialCollege-on',
          chlist: [
            {
              sid: 'IndustrialCollegeSet',
              sname: '产业学院设置',
              slink: '/industrialCollege/IndustrialCollegeSet'
            },
            {
              sid: 'IndustrialCollegeMembers',
              sname: '产业学院成员管理',
              slink: '/industrialCollege/IndustrialCollegeMembers'
            }
          ]
        },
        {
          sid: 'consortium',
          sname: '联合体',
          slink: '/consortium',
          sdesc: 'consortium',
          sdescon: 'consortium-on',
          chlist: [
            {
              sid: 'ConsortiumSet',
              sname: '联合体设置',
              slink: '/consortium/ConsortiumSet'
            },
            {
              sid: 'ConsortiumMembers',
              sname: '联合体成员管理',
              slink: '/consortium/ConsortiumMembers'
            }
          ]
        },
        {
          sid: 'community',
          sname: '共同体',
          slink: '/community',
          sdesc: 'community',
          sdescon: 'community-on',
          chlist: [
            {
              sid: 'CommunitySet',
              sname: '共同体设置',
              slink: '/community/CommunitySet'
            },
            {
              sid: 'CommunityMembers',
              sname: '共同体成员管理',
              slink: '/community/CommunityMembers'
            }
          ]
        },
        {
          sid: 'practiceCenter',
          sname: '产教融合实践中心',
          slink: '/practiceCenter',
          sdesc: 'practiceCenter',
          sdescon: 'practiceCenter-on',
          chlist: [
            {
              sid: 'PracticeCenterSet',
              sname: '产教融合实践中心设置',
              slink: '/practiceCenter/PracticeCenterSet'
            },
            {
              sid: 'PracticeCenterMembers',
              sname: '产教融合实践中心成员管理',
              slink: '/practiceCenter/PracticeCenterMembers'
            }
          ]
        },
        {
          sid: 'eduGroup',
          sname: '职教集团管理',
          slink: '/eduGroup',
          sdesc: 'group',
          sdescon: 'group-on',
          chlist: [
            {
              sid: 'EduGroupMgt',
              sname: '集团设置',
              slink: '/EduGroupMgt',
            },
            {
              sid: 'EduGroupMemberMgt',
              sname: '成员管理',
              slink: '/EduGroupMemberMgt',
            },
            {
              sid: 'EduGroupNotice',
              sname: '集团通知公告管理',
              slink: '/EduGroupNotice',
            },
            {
              sid: 'EduGroupNewsMgtGroup',
              sname: '集团新闻动态管理',
              slink: '/EduGroupNewsMgtGroup',
            },
            {
              sid: 'EduGroupMemberNewsAudit',
              sname: '成员新闻动态审核',
              slink: '/EduGroupMemberNewsAudit',
            },
            {
              sid: 'EduGroupMemberCoAudit',
              sname: '成员合作需求审核',
              slink: '/EduGroupMemberCoAudit',
            },
            {
              sid: 'EduGroupNewsMgt',
              sname: '成员新闻动态管理',
              slink: '/EduGroupNewsMgt',
            },
            {
              sid: 'EduGroupCoNeed',
              sname: '成员合作需求管理',
              slink: '/EduGroupCoNeed',
            },

          ]
        },
        {
          sid: 'xxptsz',
          sname: '平台信息设置',
          slink: '/xxptsz',
          sdesc: 'platform',
          sdescon: 'platform-on',
          chlist: [
            {
              sid: 'lbtsz',
              sname: 'banner设置',
              slink: '/xxptsz/lbtsz',
            },
            {
              sid: 'dhsz',
              sname: '导航设置',
              slink: '/xxptsz/dhsz',
            },
            {
              sid: 'lmsz',
              sname: '栏目设置',
              slink: '/xxptsz/lmsz',
            },
            {
              sid: 'lmnrgl',
              sname: '栏目内容管理',
              son: [
                {
                  sid: 'hzxq',
                  sname: '合作需求',
                  slink: '/xxptsz/hzxq',
                },
                {
                  sid: 'xwdt',
                  sname: '新闻动态',
                  slink: '/xxptsz/xwdt',
                },
                {
                  sid: 'tzgg',
                  sname: '通知公告',
                  slink: '/xxptsz/tzgg',
                },
                {
                  sid: 'zcwj',
                  sname: '政策文件',
                  slink: '/xxptsz/zcwj',
                },
                {
                  sid: 'glwj',
                  sname: '管理文件',
                  slink: '/xxptsz/glwj',
                },
              ]
            },
            {
              sid: 'ljsz',
              sname: '链接设置',
              slink: '/xxptsz/ljsz',
            },
            {
              sid: 'jcxxsz',
              sname: '基础信息设置',
              slink: '/xxptsz/jcxxsz',
            },
            {
              sid: 'PlatResourceAppliMgt',
              sname: '平台资源申请管理',
              slink: '/xxptsz/PlatResourceAppliMgt',
            }

          ]
        },
        {
          sid: 'xqhz',
          sname: '校企合作管理',
          slink: '/xqhz',
          sdesc: 'cooperation',
          sdescon: 'cooperation-on',
          chlist: [
            {
              sid: 'NoticeControl',
              sname: '通知公告管理',
              slink: '/xqhz/NoticeControl',
            },
            {
              sid: 'News',
              sname: '新闻动态管理',
              slink: '/xqhz/News',
            },
            {
              sid: 'NewsCheckOk',
              sname: '成员单位资讯列表',
              slink: '/xqhz/NewsCheckOk',
            },
            {
              sid: 'CoordinationOK',
              sname: '成员单位合作需求列表',
              slink: '/xqhz/CoordinationOK',
            },
            {
              sid: 'NewsCheck',
              sname: '成员单位资讯审核',
              slink: '/xqhz/NewsCheck',
            },
            {
              sid: 'Coordination',
              sname: '成员单位合作需求审核',
              slink: '/xqhz/Coordination',
            },
            {
              sid: 'xqhzsz',
              sname: '校企合作设置',
              slink: '/xqhz/xqhzsz',
            },
          ]
        },
        {
          sid: 'members',
          sname: '成员账号管理',
          slink: '/members',
          sdesc: 'account',
          sdescon: 'account-on',
          chlist: [
            {
              sid: 'councilMember',
              sname: '理事会成员',
              slink: '/councilMember',
            },
            {
              sid: 'groupMember',
              sname: '职教集团（联盟）成员',
              slink: '/groupMember',
            },
            {
              sid: 'enterpriseMember',
              sname: '合作企业成员',
              slink: '/enterpriseMember',
            },
            {
              sid: 'industrialMember',
              sname: '产业学院成员',
              slink: '/industrialMember'
            },
            {
              sid: 'consortiumMember',
              sname: '联合体成员',
              slink: '/consortiumMember'
            },
            {
              sid: 'communityMember',
              sname: '共同体成员',
              slink: '/communityMember'
            },
            {
              sid: 'practiceMember',
              sname: '实践中心成员',
              slink: '/practiceMember'
            },
          ]
        },
        {
          sid: 'serviceRating',
          sname: '产教融合工作考核',
          slink: '/serviceRating',
          sdesc: 'work',
          sdescon: 'work-on',
          chlist: [
            {
              sid: 'settigItemSetting',
              sname: '考核项设置',
              slink: '/serviceRating/settigItemSetting',
            },
            {
              sid: 'yearExamineList',
              sname: '年度工作考核列表',
              slink: '/serviceRating/yearExamineList',
            },
            {
              sid: 'examineIntegralRanking',
              sname: '考核排行榜',
              slink: '/serviceRating/examineIntegralRanking',
            },
            {
              sid: 'scoringWork',
              sname: '考核评分',
              slink: '/serviceRating/scoringWork',
            },
          ]
        },
        {
          sid: 'reports',
          sname: '统计报表',
          slink: '/reports',
          sdesc: 'statistics',
          sdescon: 'statistics-on',
          chlist: [
            {
              sid: 'reportsList',
              sname: '报表列表',
              slink: '/reports/reportsList',
            },

          ]
        },
        {
          sid: 'settings',
          sname: '系统设置',
          slink: '/settings',
          sdesc: 'xtsz1',
          sdescon: 'xtsz2',
          chlist: [
            {
              sid: 'roleManagement',
              sname: '角色管理',
              slink: '/settings/roleManagement',
            },
            {
              sid: 'userAdmin',
              sname: '用户管理',
              slink: '/settings/userAdmin',
            }
          ]
        },
        {
          sid: 'message',
          sname: '消息通知管理',
          slink: '/message',
          sdesc: 'bell',
          sdescon: 'bell-on',
          chlist: [
            {
              sid: 'message',
              sname: '消息通知管理',
              slink: '/Message',
            },
          ]
        }
      ],
      ss2: "",
    }
  },
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'sidebar',
      'permissionMenus'
    ]),
    isCollapse () {
      return !this.sidebar.opened
    }
  },
  methods: {
    handleOpen (key, keyPath) {
      // console.log(key, keyPath);
    },

    handleClose (key, keyPath) {
      // console.log(key, keyPath);
    },

    fatherMethod () {
      if (this.menus != "" && this.menus != null && this.menus != undefined) {
        //this.$router.replace('/pcsqgl')
        console.log("this.menus[0].chlist[0].slink:" + this.menus[0].chlist[0].slink);
        this.$router.replace(this.menus[0].chlist[0].slink)

      } else {
        this.$router.replace("/jsgl/zwqx")
        console.log("暂无权限");
      }

    },

    fatherMethod2 (x) {
      //快捷通道

    },
    handleSelect (key, keyPath) {
      //console.log(key,keyPath);
    },
    getMenu () {
      let cs = {
        LSID: this.LSID,
      };

    },
    cre1 () {
      var that = this;
      this.ss2 = setInterval(function () {
        that.LSID = localStorage.getItem("No");
        //  that.LSID = '1980001';

        if (that.LSID != null && that.LSID != undefined && that.LSID != "") {
          that.cre2();
        }
      }, 1000);
    },
    cre2 () {
      clearInterval(this.ss2);
      this.getMenu();
    },
  },
  mounted () {
    window.fatherMethod = this.fatherMethod;
    window.fatherMethod2 = this.fatherMethod2;
    window.getList = this.getList;
  },
  created () {
    //  this.cre1();

  },

}

</script>
<style scoped>
.sidebarOut {
  box-sizing: border-box;
  background-color: #485077;
  position: fixed;
  z-index: 2000;
  width: 13.95vw;
  display: flex;
  justify-content: center;
  padding-top: 10px;
}
.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 45px;
  line-height: 50px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;
}
.sidebar-title {
  display: inline-block;
  margin: 0;
  color: #fff;
  font-weight: 600;
  line-height: 50px;
  font-size: 14px;
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
  vertical-align: middle;
}
*,
*:before,
*:after {
  box-sizing: initial !important;
}
</style>


<style scoped>
.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;
}
.sidebar-title {
  display: inline-block;
  margin: 0;
  color: #fff;
  font-weight: 600;
  line-height: 50px;
  font-size: 14px;
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
  vertical-align: middle;
}
*,
*:before,
*:after {
  box-sizing: initial !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar.vue